import React, { useEffect, useState } from 'react'
import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';
import { styled } from '@mui/material/styles';

const ItemStyled = styled(Paper)(({ theme, selected, disabled }) => ({
    backgroundColor: selected ? '#95d6e6' : disabled ? 'grey': '#fff',
    '&:hover': {
        cursor: disabled ? "default" : "pointer",
        backgroundColor : disabled ? "default" : selected ? '#95d6e6' : '#ededed'
     },
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,


}));

const Item = ({value, id, onSelect, selected, disabled}) => {

    return (
        <ItemStyled key={id} id={id} onClick={() => disabled ? undefined : onSelect(id)} selected={selected === id} disabled={disabled}>{value}</ItemStyled>
    ) 
}

export default Item